import { SparklesIcon } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "../ui/tooltip";

type Props = {
  t: (key: string) => string;
  enrichmentLevel?: number;
};

/**
 * Not enriched indicator: dash + sparkles icon with tooltip.
 */
export function NotEnrichedIndicator({ t, enrichmentLevel }: Props): React.ReactElement {
  const tooltipKey =
    enrichmentLevel !== undefined && enrichmentLevel >= 2
      ? "components.dataTableCompanies.columns.notFoundByAiTooltip"
      : "components.dataTableCompanies.columns.notEnrichedTooltip";

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className="flex items-center gap-1 text-muted-foreground/50 cursor-help">
            <span>—</span>
            <SparklesIcon className="size-3" />
          </span>
        </TooltipTrigger>
        <TooltipContent side="top" className="max-w-xs">
          {t(tooltipKey)}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
